const Entity = () => import('../views/Entity.vue')

export default [
  {
    path: 'entities',
    component: Entity,
    meta: { requiresAuth: true },
    name: 'entities'
  }
]